module.exports = __webpack_public_path__ + "pic/2.7575221e.png";